export const CODE_NOT_CONFIRMED = 'Auth.form.error.confirmed'
